import React from 'react';
import { prop } from 'ramda';
import { useDeviceSelector } from 'js/store/hooks';

import { OverflowSlider } from './components/OverflowSlider';
import { GridPagingSlider } from './components/GridPagingSlider';

export const Carousel = () => {
    const isDesktop = useDeviceSelector(prop('isDesktop'));

    return isDesktop ? <GridPagingSlider /> : <OverflowSlider />;
};
